@let currentRoom = room();

<div class="room-card__image">
  @if (currentRoom.photo && currentRoom.photo.url) {
    <img [ngSrc]="currentRoom.photo.url" fill alt="" />
  }
</div>
<div class="room-card__body">
  <span class="ui-heading-6-bold--s">{{ currentRoom.name }}</span>
  <span class="room-card__location">
    {{ currentRoom.siteName }} {{ currentRoom.buildingName }}
    {{ currentRoom.floorName }}
  </span>
  <span class="room-card__description">{{ currentRoom.description }}</span>
  <span class="room-card__meta">
    {{ currentRoom.type }} · {{ currentRoom.capacity }}
  </span>
</div>
